import useSWR from 'swr'
import { jsonGetFetcher } from '../src/fetchers'

const runnerBlack = '/runner-black.png'
const runnerBlue = '/runner-blue.png'
const runnerBubblegum = '/runner-bubblegum.png'
const runnerDarkBlue = '/runner-dakrblue.png'
const runnerDarkGray = '/runner-darkgray.png'
const runnerDarkGreen = '/runner-darkgreen.png'
const runnerDarkOrange = '/runner-darkorange.png'
const runnerDarkRed = '/runner-darkred.png'
const runnerDarkTeal = '/runner-darkteal.png'
const runnerDarkYellow = '/runner-darkyellow.png'
const runnerGray = '/runner-darkgray.png'
const runnerGreen = '/runner-green.png'
const runnerLightPurple = '/runner-lightpurple.png'
const runnerLightRed = '/runner-lightred.png'
const runnerOrange = '/runner-orange.png'
const runnerPea = '/runner-pea.png'
const runnerPeach = '/runner-peach.png'
const runnerPurple = '/runner-purple.png'
const runnerTeal = '/runner-teal.png'
const runnerPink = '/runner-pink.png'

const runnerColors = {
  runnerOrange,
  runnerDarkGray,
  runnerDarkOrange,
  runnerDarkYellow,
  runnerDarkRed,
  runnerBubblegum,
  runnerDarkBlue,
  runnerDarkGreen,
  runnerBlue,
  runnerDarkTeal,
  runnerGray,
  runnerGreen,
  runnerLightPurple,
  runnerLightRed,
  runnerPeach,
  runnerPurple,
  runnerTeal,
  runnerPea,
  runnerBlack,
  runnerPink
}

function useGroupResults (group, token) {
  const url = `${process.env.API}/groups/${group && group.id}/results`
  
  const defaultHook = {
    progressPoints: [],
    challenges: [],
    results: [],
    challengeDistance: 0,
    loaded: false,
    loading: true,
    error: false
  }

  let { data, error, isLoading } = useSWR(group && group.id ? [url, token] : null, jsonGetFetcher, { revalidateOnMount: true })

  if (!error && !data) return { ...defaultHook, loading: Boolean(group && group.id), loaded: !(group && group.id) }

  if (error) {
    if (error.status === 401) {
      // user hook will handle logout, just return empty data
      return { ...defaultHook, loading: false }
    }
    console.error(error)
    return { ...defaultHook, error: true, loading: false }
  }
  

  let challengeDistance = 0
  let isRank = false
    
  let x = 0
  const keys = Object.keys(runnerColors)
  const challenges = data.sort((a, b) => {
    if (a.challengeName.toLowerCase() === b.challengeName.toLowerCase()) return 0
    if (a.challengeName.toLowerCase() > b.challengeName.toLowerCase()) return 1
    return -1
  })
  .reduce((memo, d, i) => {
    if (i === 0) {
      challengeDistance = d.distance
      isRank = d.isRank
    }
    let hasTeamIcon = false
    let photo = runnerColors[keys[i % keys.length]]
    if (group.map && group.map.teamIcons && group.map.teamIcons[d.id]) {
      photo = group.map.teamIcons[d.id]
      hasTeamIcon = true
    } else if (d.logo) {
      photo = `${process.env.CDN}/${d.logo}` // use chalenge logo
      hasTeamIcon = true
    }
    memo[d.id] = {
      key: keys[i % keys.length],
      photo,
      hasTeamIcon,
      isRank: d.isRank,
      isTeamChallenge: d.isTeamChallenge
    }
    return memo
  }, {})

  const results = data.map(d => {
    const measureMap = {
      distance: 'sumDistance',
      elevation: 'sumElevation',
      durationGoal: 'sumDuration',
      activityGoal: 'activityCount',
      points: 'sumPoints'
    }
    const currentMeasure = measureMap[d.measure]
    
    if (!currentMeasure || parseFloat(d[currentMeasure]) < parseFloat(d[d.measure])) {
      delete d.maxDate
      return d
    }
    return d
  })

  const progressPoints = data.map(d => {
    return {
      id: d.id,
      distance: d.sumDistance,
      duration: d.sumDuration,
      points: d.sumPoints,
      challengeGoal: d[challenges[d.id].measure],
      challengeMeasure: d[challenges[d.id].measure],
      fullname: d.challengeName,
      icon: challenges[d.id].photo,
      photo: challenges[d.id].hasTeamIcon && challenges[d.id].photo
    }
  })

  return {
    progressPoints,
    challenges,
    results,
    challengeDistance,
    isRank,
    loaded: true,
    loading: false,
    error
  }
}

export default useGroupResults 
